export default "__VITE_ASSET__D5137hV___"